import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './ApiDocs.css';

const splitHeadingLetters = (text) =>
  text.split('').map((character, index) => (
    <span
      key={`${text}-${index}`}
      className={`api-docs-heading-letter${character === ' ' ? ' is-space' : ''}`}
      style={{ '--letter-index': index }}
      aria-hidden="true"
    >
      {character === ' ' ? '\u00A0' : character}
    </span>
  ));

const ApiDocsPage = () => {
  const [isHeadingVisible, setIsHeadingVisible] = useState(false);

  useEffect(() => {
    const timer = window.setTimeout(() => {
      setIsHeadingVisible(true);
    }, 80);

    return () => {
      window.clearTimeout(timer);
    };
  }, []);

  return (
    <div className="api-docs-page-wrapper">
      <div className="api-docs-page-container api-docs-page">
        <div className="api-docs-back-link">
          <Link to="/">&larr; Back to Home</Link>
        </div>

        <div className="api-docs-page-hero">
          <h1
            className={`api-docs-heading ${isHeadingVisible ? 'is-visible' : ''}`}
            aria-label="API Documentation"
          >
            {splitHeadingLetters('API Documentation')}
          </h1>
          <p>
            Explore BlackRoth's API ecosystem designed to enable seamless system
            integration, automation, and scalable application development across
            enterprise environments.
          </p>
        </div>

        <section className="api-docs-page-section">
          <h2 className="api-docs-section-heading">Overview</h2>
          <p>
            BlackRoth APIs follow modern RESTful design principles, ensuring
            predictable resource structures, standardized HTTP methods, and
            secure data exchange. Our APIs are built for performance,
            reliability, and enterprise-grade scalability.
          </p>
        </section>

        <section className="api-docs-page-section">
          <h2 className="api-docs-section-heading">Authentication &amp; Security</h2>
          <p>
            All API endpoints are secured using token-based authentication.
            Access keys, JWT tokens, and role-based authorization mechanisms
            ensure that integrations remain protected and compliant with
            security best practices.
          </p>
        </section>

        <section className="api-docs-page-section">
          <h2 className="api-docs-section-heading">Endpoints &amp; Usage</h2>
          <p>
            Our documentation provides detailed endpoint references, request
            parameters, response schemas, and example payloads. Developers can
            quickly test and implement integrations using standardized request
            formats.
          </p>
        </section>

        <section className="api-docs-page-section">
          <h2 className="api-docs-section-heading">SDKs &amp; Developer Tools</h2>
          <p>
            To accelerate development, BlackRoth offers SDK support, code
            samples, and sandbox environments. These resources simplify
            implementation across multiple programming languages and platforms.
          </p>
        </section>
      </div>
    </div>
  );
};

export default ApiDocsPage;
